import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { SlackSettings } from "@/features/settings/SlackSettings";

/**
 * Admins only. Slack's callback lands here with ?connected=1 or ?error=...,
 * which the page turns into a toast and then drops from the address bar.
 */
export const Route = createFileRoute("/_app/settings/slack")({
  validateSearch: z.object({
    connected: z.string().optional().catch(undefined),
    error: z.string().optional().catch(undefined),
  }),
  beforeLoad: ({ context }) => {
    if (context.me.user.role !== "admin") throw redirect({ to: "/settings/notifications" });
  },
  component: SlackSettings,
});
